import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const useTableApi = (getApi, isCallApiOnMount) => {

    const [opendPageIndex, setOpenedPageIndex] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [selectedPageSize, setSelectedPageSize] = useState(10);
    const [filterOptions, setFilterOptions] = useState({});
    const [isExporting, setIsExporting] = useState(false);
    const [recordsInfo, setRecordsInfo] = useState({ data: [], totalRecords: "" });
    const [isLoading, setIsLoading] = useState(true);

    const onPageChange = async (index) => {
        if (isLoading) return null;
        setIsLoading(true);
        // if (Boolean(opendPageIndex < index)) {
            let res = await getApi({ ...filterOptions, page_number: index, page_size: selectedPageSize });
            if (res.ok) {
                setRecordsInfo((pre) => {
                    // return { data: [...pre.data, ...res?.data?.records], totalRecords: res?.data?.totalRecords }
                    return { data: res?.data?.records, totalRecords: res?.data?.totalRecords }
                });
                if (res?.data?.records.length) {
                    setOpenedPageIndex(index);
                    setPageIndex(index);
                }
            }
        // } else {
        //     setPageIndex(index)
        // }
        setIsLoading(false)

    };

    //make api request whenever page change and greater than pre page size
    const onPageSizeChange = async (page_size, force = false) => {
        let dataLen = recordsInfo.data.length;
        if (Boolean(dataLen < page_size) || force) {
            setIsLoading(true);
            let res = await getApi({ ...filterOptions, page_size, page_number: 0 })
            setRecordsInfo({ data: res?.data?.records || [], totalRecords: res?.data?.totalRecords });
            setSelectedPageSize(page_size);
            setIsLoading(false);
        } else {
            let calcIndex = Math.floor(dataLen / page_size);
            setSelectedPageSize(page_size);
            setPageIndex(0);
            setRecordsInfo((preState => {
                let modifyDataList = recordsInfo.data.slice(0, (calcIndex * page_size));
                setOpenedPageIndex((modifyDataList.length / page_size) - 1);
                return { ...preState, data: modifyDataList };
            }));

        }
    };

    useEffect(() => {
        if (isCallApiOnMount) getApi({ page_number: 0, page_size: 10 }).then(res => {
            setRecordsInfo({ data: res?.data?.records || [], totalRecords: (res?.data?.totalRecords || 0) });
            setIsLoading(false)
        })
    }, []);

    const conditionalCall = async (state, operationType) => {
        let res;
        switch (operationType) {
            case "clear_all":
                setFilterOptions({});
                res = await getApi({ page_size: selectedPageSize, page_number: 0 });//api call
                return res;
            case "clear_previous":
                setFilterOptions(state);
                res = await getApi({ page_size: selectedPageSize, page_number: 0, ...state });//api call
                return res;
            default:
                setFilterOptions(Object.assign(filterOptions, state));
                res = await getApi({ page_size: selectedPageSize, page_number: 0, ...filterOptions, ...state });//api call
                return res;
        }
    };

    const changeFilterOptions = async (state = {}, operationType = false) => {
        setIsLoading(true);
        const res = await conditionalCall(state, operationType);
        if (res.ok) {
            const data = { data: res?.data?.records || [], totalRecords: res?.data?.totalRecords };
            setOpenedPageIndex(0);
            setPageIndex(0);
            setRecordsInfo(data);
            setIsLoading(false);
            return data;
        } else {
            return toast.error(res?.message);
        }
    };

    return {
        opendPageIndex,
        setOpenedPageIndex,
        pageIndex,
        setPageIndex,
        selectedPageSize,
        setSelectedPageSize,
        filterOptions,
        setFilterOptions,
        isExporting,
        setIsExporting,
        recordsInfo,
        setRecordsInfo,
        setIsLoading,
        isLoading,
        onPageChange,
        onPageSizeChange,
        changeFilterOptions
    }
};

export default useTableApi;